export const OHL  = {
    name: 'DV 1196/1 TS RUDNIK 1 - TS RUDNIK3',
    voltage: '110',
    regionCode: 'BGD',
    stanice: [],
    position: 'N',
    stubovi: [
        { index: 1, name: 'P01', lat: 44.7126 , lng: 21.2553, sys: 1, portal: true},
        { index: 2, name: '1', lat: 44.7125 , lng: 21.2556, sys: 1},
        { index: 3, name: '2', lat: 44.713 , lng: 21.2568, sys: 1},
        { index: 4, name: '3', lat: 44.7147 , lng: 21.2582, sys: 1},
        { index: 5, name: '4', lat: 44.717 , lng: 21.26, sys: 1},
        { index: 6, name: '5', lat: 44.7193 , lng: 21.2618, sys: 1},
        { index: 7, name: '6', lat: 44.7214 , lng: 21.2635, sys: 1},
        { index: 8, name: '7', lat: 44.7238 , lng: 21.2653, sys: 1},
        { index: 9, name: '8', lat: 44.7261 , lng: 21.2672, sys: 1},
        { index: 10, name: '9', lat: 44.7284 , lng: 21.269, sys: 1},
        { index: 11, name: '10', lat: 44.7307 , lng: 21.2708, sys: 1},
        { index: 12, name: '11', lat: 44.733 , lng: 21.2727, sys: 1},
        { index: 13, name: '12', lat: 44.7352 , lng: 21.2744, sys: 1},
        { index: 14, name: '12a', lat: 44.7366 , lng: 21.2765, sys: 2},
        { index: 15, name: '12b', lat: 44.7382 , lng: 21.2766, sys: 2},
        { index: 16, name: 'P-02', lat: 44.7386 , lng: 21.2761, sys: 1, portal: true}
    ],
    rasponi: [
        { name: 'P01 - 1', position: [{ lat: 44.7126 , lng: 21.2553 }, { lat: 44.7125 , lng: 21.2556 }] },
        { name: '1 - 2', position: [{ lat: 44.7125 , lng: 21.2556 }, { lat: 44.713 , lng: 21.2568 }] },
        { name: '2 - 3', position: [{ lat: 44.713 , lng: 21.2568 }, { lat: 44.7147 , lng: 21.2582 }] },
        { name: '3 - 4', position: [{ lat: 44.7147 , lng: 21.2582 }, { lat: 44.717 , lng: 21.26 }] },
        { name: '4 - 5', position: [{ lat: 44.717 , lng: 21.26 }, { lat: 44.7193 , lng: 21.2618 }] },
        { name: '5 - 6', position: [{ lat: 44.7193 , lng: 21.2618 }, { lat: 44.7214 , lng: 21.2635 }] },
        { name: '6 - 7', position: [{ lat: 44.7214 , lng: 21.2635 }, { lat: 44.7238 , lng: 21.2653 }] },
        { name: '7 - 8', position: [{ lat: 44.7238 , lng: 21.2653 }, { lat: 44.7261 , lng: 21.2672 }] },
        { name: '8 - 9', position: [{ lat: 44.7261 , lng: 21.2672 }, { lat: 44.7284 , lng: 21.269 }] },
        { name: '9 - 10', position: [{ lat: 44.7284 , lng: 21.269 }, { lat: 44.7307 , lng: 21.2708 }] },
        { name: '10 - 11', position: [{ lat: 44.7307 , lng: 21.2708 }, { lat: 44.733 , lng: 21.2727 }] },
        { name: '11 - 12', position: [{ lat: 44.733 , lng: 21.2727 }, { lat: 44.7352 , lng: 21.2744 }] },
        { name: '12 - 12a', position: [{ lat: 44.7352 , lng: 21.2744 }, { lat: 44.7366 , lng: 21.2765 }] },
        { name: '12a - 12b', position: [{ lat: 44.7366 , lng: 21.2765 }, { lat: 44.7382 , lng: 21.2766 }] },
        { name: '12b - P-02', position: [{ lat: 44.7382 , lng: 21.2766 }, { lat: 44.7386 , lng: 21.2761 }] }
    ]
}